const tabs = document.querySelector(".tabs");

if (tabs) {
    const tabsNav = document.querySelector(".tabs-nav");
    const tabsNavButtons = tabsNav.querySelectorAll(".tabs-nav__item");
    const tabsBody = document.querySelector(".tabs-body");
    const tabsBodyItems = tabsBody.querySelectorAll(".tabs-body__item");

    tabsNavButtons.forEach(function (el, index) {
        el.addEventListener("click", function () {
            addNavButtonActive(el);
            addBodyItemActive(index);
            removeNavButtonActive(index);
            removeNavItemsActive(index);
        });
    });

    function addBodyItemActive(index) {
        tabsBodyItems[index].classList.add("active");
    }

    function addNavButtonActive(el) {
        el.classList.add("active");
    }

    function removeNavButtonActive(index) {
        tabsNavButtons.forEach(function (el, idx) {
            if (index !== idx) {
                el.classList.remove("active");
            }
        });
    }

    function removeNavItemsActive(index) {
        tabsBodyItems.forEach(function (el, idx) {
            if (index !== idx) {
                el.classList.remove("active");
            }
        });
    }
}
